
import React from 'react';
import { Progress } from 'antd';

import './eachActiveJobs.scss'

export default (props) =>{
    return (
        <div className="report-list">
            <ul>
                <li>{props.name}</li>
                <li>{props.jobStart}</li>
                <li>{props.jobType}</li>
                <li>{props.source}</li>
                <li>{props.destination}</li>
                <li><Progress percent={props.percentage} format={percent => `${props.percentage}`} size="small" status="active" /></li>
                <li>{props.action}</li>
                {/* <li>
                    <Tooltip title="Trigger Now">
                    <Button
                        className="replication-upload-btn"
                        icon="upload"
                        onClick={e =>
                            showTriggerConfirm(e, props.handleTriggerClick, props.id, (props.source + " > " + props.destination))
                        }
                    />
                    </Tooltip>
                    <Tooltip title="Delete">
                    <Button
                        className="replication-delete-btn"
                        icon="delete"
                        onClick={e =>
                            showDeleteConfirm(e, props.handleDeleteClick, props.id, (props.source + " > " + props.destination))
                        }
                    />
                    </Tooltip>

                </li> */}
            </ul>
            
        </div>
    )
}

